import { render, staticRenderFns } from "./modal-form-dialog.vue?vue&type=template&id=345612c4"
import script from "./modal-form-dialog.vue?vue&type=script&lang=js"
export * from "./modal-form-dialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/mse/texting-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('345612c4')) {
      api.createRecord('345612c4', component.options)
    } else {
      api.reload('345612c4', component.options)
    }
    module.hot.accept("./modal-form-dialog.vue?vue&type=template&id=345612c4", function () {
      api.rerender('345612c4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/quick-send-list/modal-form-dialog.vue"
export default component.exports